<template>
  <section class="section">
    <h1 class="title is-size-4 has-text-centered">My Students</h1>
    <div class="columns container students-super-container">
      <div class="column is-three-fifths students-container">
        <div v-for="(student,i) in students" class="student box" :key="i">
          <div class>
            <h2 class="subtitle is-3">{{student.full_name}}</h2>
            <div class="columns">
              <div class="column">
                <img class="image is-128x128" :src="student.profileUrl" alt="Image">
              </div>
              <div class="column">
                <h2>Projects</h2>
                <div v-for="(project, j) in student.user_project_documents" :key="j">
                  <a
                    @click.prevent="gotoProjectReview(student.full_name,project.id)"
                    href
                  >{{project.name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseHelper from "../helpers/BaseHelper";

export default {
  name: "Students",
  mixins: [BaseHelper],
  data() {
    return {
      students: this.$store.state.auth.user.students
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.students-container {
  margin-left: auto;
  margin-right: auto;
  .student {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
}
.students-super-container {
  margin-left: auto;
  margin-right: auto;
}
</style>

